import { Component, OnInit } from '@angular/core';
import { GlobalService } from '@services/index';
import { CMSApiService } from '@services/api/cms-api.service';

@Component({
  selector: 'app-press',
  templateUrl: './press.component.html',
  styleUrls: ['./press.component.css'],
})
export class PressComponent implements OnInit {
  content: string;
  isLoading = true;

  constructor(
    private globalService: GlobalService,
    private cms: CMSApiService
  ) {}

  ngOnInit() {
    this.load();
  }

  load() {
    this.cms.getToken().subscribe((retToken) => {
      this.globalService.cmsToken = retToken.access_token;
      this.cms.getPress().subscribe((ret) => {
        this.content = ret.items[0].data.value.iv;
        console.log(this.content);
        this.isLoading = false;
      });
    });
  }
}
